// Shared decorative rain-drop pattern background used on ~30+ marketing page
// heroes. Was a raw <img src="/assets/marketing/hero-pattern.webp"> repeated
// on every page — one fixed 1440x624 (29.5 KiB) asset shipped to every
// viewport, with no width/height attrs (a CLS risk). Centralizing it here so
// the responsive srcset and dimensions are fixed once, everywhere.
const FULL = "/assets/marketing/hero-pattern.webp";
const BASE = "/assets/marketing/hero-pattern-";

interface HeroPatternBackgroundProps {
  className: string;
  /** Set for pages where this is the (or a) LCP candidate — matches the
   * original markup's explicit eager/high-priority hint. Most pages don't
   * set this and get the browser's normal default loading behavior. */
  priority?: boolean;
}

// Transparent 1x1 GIF. Below md the pattern is not downloaded at all: it was
// the mobile LCP element on /demo, /blog, /hr-tool-and-template/* etc. and
// competed with the real hero content for bandwidth on slow connections.
const TRANSPARENT_PIXEL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

export function HeroPatternBackground({ className, priority }: HeroPatternBackgroundProps) {
  // <source> only matches at md+ (tablet/desktop keep the exact same image,
  // srcset and priority). Phones fall back to the transparent pixel with the
  // caller's className untouched, so layout is identical and nothing is fetched.
  return (
    <picture>
      <source
        media="(min-width: 768px)"
        srcSet={`${BASE}640w.webp 640w, ${BASE}960w.webp 960w, ${FULL} 1440w`}
        sizes="100vw"
        width={1440}
        height={624}
      />
      <img
        src={TRANSPARENT_PIXEL}
        alt=""
        aria-hidden="true"
        width={1440}
        height={624}
        className={className}
        {...(priority ? { loading: "eager" as const, fetchPriority: "high" as const } : {})}
      />
    </picture>
  );
}
